import routes from '../routes';
import { UserTypes } from 'src/modules/Auth/store/types';
import { RoutePathsFn, IRouteModule, RoutesModules } from '../types';
import GeoSearchView from '../../GeoSearch/View/GeoSearchView';
import GeoSearchForm from '../../GeoSearch/Search/GeoSearchForm';
import GeoSearchStats from '../../GeoSearch/Stats/GeoSearchStats';
import GeoSearchResult from '../../GeoSearch/Result/GeoSearchResult';
import GeoSearchPhoto from '../../GeoSearch/Photo/GeoSearchPhoto';
import GeoSearchManualForm from 'src/modules/GeoSearch/ManualSearch/GeoSearchManualForm';

const moduleRoutes: RoutePathsFn = () => ([
  {
    paths: [routes.GEOSEARCHES_VIEW],
    component: GeoSearchView,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN, UserTypes.LAWENFORCEMENTAGENT]
  },
  {
    paths: [routes.GEOSEARCH_FORM],
    component: GeoSearchForm,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  },
  {
    paths: [routes.GEOSEARCH_MANUAL_FORM],
    component: GeoSearchManualForm,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN, UserTypes.LAWENFORCEMENTAGENT]
  },
  {
    paths: [routes.GEOSEARCH_RESULT],
    component: GeoSearchResult,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN, UserTypes.LAWENFORCEMENTAGENT]
  },
  {
    paths: [routes.GEOSEARCH_STATS],
    component: GeoSearchStats,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  },
  {
    paths: [routes.GEOSEARCH_PHOTO],
    component: GeoSearchPhoto,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN, UserTypes.LAWENFORCEMENTAGENT]
  }
]);

export const geosearchModule = (userType: UserTypes): IRouteModule => ({
  name: RoutesModules.GEOSEARCH,
  routes: moduleRoutes(),
  navbar: routes.GEOSEARCHES_VIEW,
  sidebar: [
    {
      navTitle: 'Searches',
      route: routes.GEOSEARCHES_VIEW
    },
    {
      navTitle: 'Perform a new search',
      route: routes.GEOSEARCH_FORM
    },
    {
      navTitle: `Perform a ${userType === UserTypes.LAWENFORCEMENTAGENT ? 'new' : 'manual'} search`,
      route: routes.GEOSEARCH_MANUAL_FORM
    },
    {
      navTitle: 'Stats',
      route: routes.GEOSEARCH_STATS
    }
  ]
});